import styles from './MyOrder.module.scss';
import leftArrow from '../../assets/leftArrow02.png';
import rightArrow3 from '../../assets/rightArrow03.png';
import exclamation from '../../assets/exclamation.png';
import bottomArrow02 from '../../assets/bottomArrow02.png';
import Header from '../../components/Header/Header';
import Footer from '../../components/Footer/Footer';
import { useNavigate } from 'react-router-dom';
import { isMobile } from 'react-device-detect';
import OrderFrame from '../../components/OrderFrame/OrderFrame';
import { IOrderDataType } from '../OrderComplete/OrderComplete';
import { useEffect, useState } from 'react';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { ko, enUS } from 'date-fns/esm/locale';
import { IMyPageInfoType } from '../MyPage/MyPage';
import axiosClient from '../../libs/axiosClient';
import LoginHandler from '../../components/LoginHandler/LoginHandler';
import { useTranslation } from 'react-i18next';
const dateList = ['All', 'Last 1 month', 'Last 3 months', 'Last 6 months'];
function MyOrder() {
  const navigate = useNavigate();
  const [startDate, setStartDate] = useState(new Date());
  const [endDate, setEndDate] = useState(new Date());
  const [selectedDateIdx, setSelectedDateIdx] = useState(0);
  const [guideOpen, setGuideOpen] = useState(false);
  const [orderData, setOrderData] = useState<IOrderDataType[]>([]);
  function handleDateChange(idx: number) {
    setSelectedDateIdx(idx);
    let now = new Date();
    let startDate: Date;
    if (idx == 0) startDate = new Date(now.setFullYear(now.getFullYear() - 1));
    else if (idx == 1) startDate = new Date(now.setMonth(now.getMonth() - 1));
    else if (idx == 2) startDate = new Date(now.setMonth(now.getMonth() - 3));
    else startDate = new Date(now.setMonth(now.getMonth() - 6));
    setStartDate(startDate);
    setEndDate(new Date());
  }
  useEffect(() => {
    let now = new Date();
    setStartDate(new Date(now.setFullYear(now.getFullYear() - 1)));
  }, []);
  const [myPageInfo, setMyPageInfo] = useState<IMyPageInfoType>();
  useEffect(() => {
    axiosClient.get('/data/mypage').then((res) => {
      setMyPageInfo(res.data.data);
    });
  }, []);
  useEffect(() => {
    axiosClient.get('/data/order').then((res) => setOrderData(res.data.data));
  }, []);
  function getOrderInfo() {
    let newStartDate =
      startDate.getFullYear() +
      '-' +
      ('0' + (startDate.getMonth() + 1)).substr(-2) +
      '-' +
      ('0' + startDate.getDate()).substr(-2);
    let newEndDate =
      endDate.getFullYear() +
      '-' +
      ('0' + (endDate.getMonth() + 1)).substr(-2) +
      '-' +
      ('0' + endDate.getDate()).substr(-2);
    axiosClient
      .get(`/data/order?started_date=${newStartDate}&ended_date=${newEndDate}`)
      .then((res) => setOrderData(res.data.data));
  }
  const { t, i18n } = useTranslation();
  return (
    <div className={`${styles.container} ${!isMobile ? styles.isPC : ''}`}>
      <LoginHandler />
      <Header />
      {isMobile ? (
        <div className={styles.header} onClick={() => navigate(-1)}>
          <img src={leftArrow} alt="arrow" />
          <span>{t('myPage.12')}</span>
        </div>
      ) : (
        <div className={styles.pcHeader}>
          <span>{t('myPage.12')}</span>
        </div>
      )}
      <div className={styles.orderStatus}>
        <h3>{t('myPage.6')}</h3>
        <div className={styles.statusList}>
          <div
            className={`${styles.status} ${
              myPageInfo && myPageInfo?.order_count.결제대기 > 0
                ? styles.hit
                : ''
            }`}
          >
            <span>{myPageInfo && myPageInfo?.order_count.결제대기}</span>
            <span>{t('myPage.7')}</span>
          </div>
          <img src={rightArrow3} alt="rightArrow" />
          <div
            className={`${styles.status} ${
              myPageInfo && myPageInfo?.order_count.결제완료 > 0
                ? styles.hit
                : ''
            }`}
          >
            <span>{myPageInfo && myPageInfo?.order_count.결제완료}</span>
            <span>{t('myPage.8')}</span>
          </div>
          <img src={rightArrow3} alt="rightArrow" />
          <div
            className={`${styles.status} ${
              myPageInfo && myPageInfo?.order_count.배송준비 > 0
                ? styles.hit
                : ''
            }`}
          >
            <span>{myPageInfo && myPageInfo?.order_count.배송준비}</span>
            <span>{t('myPage.9')}</span>
          </div>
          <img src={rightArrow3} alt="rightArrow" />
          <div
            className={`${styles.status} ${
              myPageInfo && myPageInfo?.order_count.배송중 > 0 ? styles.hit : ''
            }`}
          >
            <span>{myPageInfo && myPageInfo?.order_count.배송중}</span>
            <span>{t('myPage.10')}</span>
          </div>
          <img src={rightArrow3} alt="rightArrow" />
          <div
            className={`${styles.status} ${
              myPageInfo && myPageInfo?.order_count.배송완료 > 0
                ? styles.hit
                : ''
            }`}
          >
            <span>{myPageInfo && myPageInfo?.order_count.배송완료}</span>
            <span>{t('myPage.11')}</span>
          </div>
        </div>
      </div>
      <div className={styles.orderDateForm}>
        <ul className={`${styles.dateList} ${isMobile ? styles.isMobile : ''}`}>
          {dateList.map((date, idx) => (
            <li
              key={date}
              className={idx == selectedDateIdx ? styles.hit : ''}
              onClick={() => handleDateChange(idx)}
            >
              {date}
            </li>
          ))}
        </ul>
        <div className={styles.dateChangeWrap}>
          <div className={styles.startDate}>
            <DatePicker
              selected={startDate}
              selectsStart
              startDate={startDate}
              endDate={endDate}
              locale={enUS}
              dateFormat="MM.dd.yyyy"
              onChange={(date: Date) => setStartDate(date)}
            />
          </div>
          <span>~</span>
          <div className={styles.endDate}>
            <DatePicker
              selected={endDate}
              selectsEnd
              startDate={startDate}
              locale={enUS}
              dateFormat="MM.dd.yyyy"
              onChange={(date: Date) => setEndDate(date)}
              endDate={endDate}
              minDate={startDate}
            />
          </div>
          <div className={styles.dateSubmit} onClick={getOrderInfo}>
            {t('myPage.49')}
          </div>
        </div>
        <div className={styles.text}>
          <span>{t('myPage.48')}</span>
        </div>
      </div>
      <ul
        className={`${styles.orderListWrap} ${isMobile ? styles.isMobile : ''}`}
      >
        {orderData.map((order) => (
          <li key={order.order_id}>
            <OrderFrame orderData={order} />
          </li>
        ))}
      </ul>
      <Footer />
    </div>
  );
}
export default MyOrder;
